import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../reducers';
import { HTTPMethods } from '../../../yoello-lib/modules/API/API';
import IVenue from '../../../yoello-lib/modules/API/interfaces/IVenue';
import APIExtensions from '../../../yoello-lib/modules/API2/APIDefs';
import { useAPIV2 } from '../../../yoello-lib/modules/API2/useAPIv2';


export function usePopUpMessages() {
  const selectedVenueId = useSelector((state:IReduxAppState) => state.selectedVenueId);
  const { apiData: bannerMessages, callAPI: bannerMessagesApi, isLoading } = useAPIV2<IVenue>(APIExtensions.banner_messages, {
    query: selectedVenueId + "/banner_messages",
  });


  function onBannerMessagesSubmit(data:any){
    return new Promise(async (resolve , reject) => {
        await bannerMessagesApi( bannerMessages?.[0]?.id? HTTPMethods.PUT:HTTPMethods.POST,{
            body:data,
            query: `${selectedVenueId}/banner_messages/${bannerMessages?.[0]?.id??''}`,
        }).then((res)=>{
            return bannerMessagesApi(HTTPMethods.GET).then((res)=>{
                return resolve(res.data);
            });
        }).catch((error:any)=>{
            return reject(error)
        })
    })
    
}
  
return {
    onBannerMessagesSubmit,
    bannerMessages : bannerMessages?.[0],
    isLoading
}
}
